import * as React from "react";

const SvgShieldCheckmark = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 111.811 122.88"
    xmlSpace="preserve"
    {...{ ...props, ref }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.713 0c20.848 13.215 39.682 19.467 55.846 17.989 2.823 57.098-18.263 90.818-55.63 104.891C19.844 109.708-1.5 77.439.083 17.123c18.975.993 37.591-3.109 55.63-17.123zM33.784 66.775a2.815 2.815 0 0 1 3.658-4.276l11.494 9.875 25.18-27.684a2.818 2.818 0 0 1 3.979-.188 2.818 2.818 0 0 1 .187 3.978l-27.02 29.708-.002-.002a2.813 2.813 0 0 1-3.91.244L33.784 66.775zm21.951-59.72c18.454 11.697 35.126 17.232 49.434 15.923 2.498 50.541-16.166 80.39-49.241 92.846C23.986 104.165 5.091 75.603 6.493 22.211c16.797.88 33.275-2.751 49.242-15.156z"
    />
  </svg>
);

export default React.forwardRef(SvgShieldCheckmark);
